var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("label", { staticClass: "tw-text-sm tw-font-bold" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.$t("chooseSubmissionType")) + " *\n\t"),
      ]),
      _vm._v(" "),
      _c(
        "BaseDropdown",
        {
          directives: [
            {
              name: "data-cy",
              rawName: "v-data-cy",
              value: "submission-type-dropdown",
              expression: "'submission-type-dropdown'",
            },
            {
              name: "jest",
              rawName: "v-jest",
              value: "submission-type-dropdown",
              expression: "'submission-type-dropdown'",
            },
          ],
          ref: "submissionTypeDropdown",
          class: { warning: _vm.error },
          attrs: { items: _vm.submissionTypes },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ item }) {
                return [
                  _c(
                    "BaseRadio",
                    {
                      directives: [
                        {
                          name: "data-cy",
                          rawName: "v-data-cy",
                          value: `submission-type-${item.id}`,
                          expression: "`submission-type-${item.id}`",
                        },
                      ],
                      attrs: {
                        "radio-name": "submission-type",
                        "radio-value": item.id,
                        "radio-id": `submission-type-${item.id}`,
                      },
                      model: {
                        value: _vm.submissionType,
                        callback: function ($$v) {
                          _vm.submissionType = $$v
                        },
                        expression: "submissionType",
                      },
                    },
                    [
                      _c("template", { slot: "text" }, [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.$t(item.key)) +
                            "\n\t\t\t\t"
                        ),
                      ]),
                    ],
                    2
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c("template", { slot: "filters" }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.submissionDropdownText) + "\n\t\t"),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.error,
              expression: "error",
            },
            {
              name: "jest",
              rawName: "v-jest",
              value: "submission-type-error",
              expression: "'submission-type-error'",
            },
          ],
          staticClass: "tw-text-sm tw-font-bold tw-text-origami-red-400",
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.$t("chooseSubmissionType")) + "\n\t")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }